import * as yup from "yup";

export const creditNoteSchema = yup.object().shape({
  invoiceId: yup.string().required("credit_note.invoice_required"),

  clientId: yup.string().required("credit_note.client_required"),

  note: yup.string().optional(),

  date: yup
    .date()
    .typeError("credit_note.invalid_date")
    .required("credit_note.date_required"),

  creditAmount: yup
    .number()
    .typeError("credit_note.invalid_amount")
    .positive("credit_note.positive_amount")
    .required("credit_note.amount_required"),
});
